import { render, staticRenderFns } from "./DirectShareModal.vue?vue&type=template&id=69bf8540&lang=pug&"
import script from "./DirectShareModal.vue?vue&type=script&lang=js&"
export * from "./DirectShareModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports